module.exports = __webpack_public_path__ + "static/img/myWinBg.4adedfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/myWinBg.png
// module id = +K9h
// module chunks = 0